import BaseInstance from "../base.instance";
import {
  DATA_UTAMA_GOLONGAN_LIST,
  DATA_UTAMA_GOLONGAN_DETAIL,
  DATA_UTAMA_GOLONGAN_SAVE,
  DATA_UTAMA_GOLONGAN_DELETE,
  DATA_UTAMA_KEPANGKATAN_LIST,
  DATA_UTAMA_KEPANGKATAN_DETAIL,
  DATA_UTAMA_KEPANGKATAN_SAVE,
  DATA_UTAMA_KEPANGKATAN_DELETE,
  DATA_UTAMA_ESELON_LIST,
  DATA_UTAMA_ESELON_DETAIL,
  DATA_UTAMA_ESELON_SAVE,
  DATA_UTAMA_ESELON_DELETE,
  DATA_UTAMA_PENDIDIKAN_LIST,
  DATA_UTAMA_PENDIDIKAN_DETAIL,
  DATA_UTAMA_PENDIDIKAN_SAVE,
  DATA_UTAMA_PENDIDIKAN_DELETE,
  DATA_UTAMA_PENDIDIKAN_STUDI_LIST,
  DATA_UTAMA_PENDIDIKAN_STUDI_DETAIL,
  DATA_UTAMA_PENDIDIKAN_STUDI_SAVE,
  DATA_UTAMA_PENDIDIKAN_STUDI_DELETE,
  DATA_UTAMA_PENDIDIKAN_LEVEL_LIST,
  DATA_UTAMA_PENDIDIKAN_LEVEL_DETAIL,
  DATA_UTAMA_PENDIDIKAN_LEVEL_SAVE,
  DATA_UTAMA_PENDIDIKAN_LEVEL_DELETE,
  DATA_UTAMA_PENDIDIKAN_LEVEL_ALL,
  DATA_UTAMA_PENDIDIKAN_RUMPUN_LIST,
  DATA_UTAMA_PENDIDIKAN_RUMPUN_DETAIL,
  DATA_UTAMA_PENDIDIKAN_RUMPUN_SAVE,
  DATA_UTAMA_PENDIDIKAN_RUMPUN_DELETE,
  DATA_UTAMA_UNIT_KERJA_GROUP
} from "../constants";

const DataUtamaService = {
  // Golongan
  getGolonganList(data) {
    return BaseInstance.post(DATA_UTAMA_GOLONGAN_LIST, data);
  },
  getGolonganDetail(data) {
    return BaseInstance.post(DATA_UTAMA_GOLONGAN_DETAIL, data);
  },
  saveGolongan(data) {
    return BaseInstance.post(DATA_UTAMA_GOLONGAN_SAVE, data);
  },
  deleteGolongan(params) {
    return BaseInstance.remove(DATA_UTAMA_GOLONGAN_DELETE, { params });
  },
  // Kepangkatan
  getKepangkatanList(data) {
    return BaseInstance.post(DATA_UTAMA_KEPANGKATAN_LIST, data);
  },
  getKepangkatanDetail(id) {
    return BaseInstance.fetch(DATA_UTAMA_KEPANGKATAN_DETAIL, id);
  },
  saveKepangkatan(data) {
    return BaseInstance.post(DATA_UTAMA_KEPANGKATAN_SAVE, data);
  },
  deleteKepangkatan(params) {
    return BaseInstance.remove(DATA_UTAMA_KEPANGKATAN_DELETE, { params });
  },
  // Eselon
  getEselonList(data) {
    return BaseInstance.post(DATA_UTAMA_ESELON_LIST, data);
  },
  getEselonDetail(id) {
    return BaseInstance.fetch(DATA_UTAMA_ESELON_DETAIL, id);
  },
  saveEselon(data) {
    return BaseInstance.post(DATA_UTAMA_ESELON_SAVE, data);
  },
  deleteEselon(params) {
    return BaseInstance.remove(DATA_UTAMA_ESELON_DELETE, { params });
  },
  // Pendidikan
  getPendidikanList(data) {
    return BaseInstance.post(DATA_UTAMA_PENDIDIKAN_LIST, data);
  },
  getPendidikanDetail(id) {
    return BaseInstance.fetch(DATA_UTAMA_PENDIDIKAN_DETAIL, id);
  },
  savePendidikan(data) {
    return BaseInstance.post(DATA_UTAMA_PENDIDIKAN_SAVE, data);
  },
  deletePendidikan(params) {
    return BaseInstance.remove(DATA_UTAMA_PENDIDIKAN_DELETE, { params });
  },
  // Studi
  getStudiList(data) {
    return BaseInstance.post(DATA_UTAMA_PENDIDIKAN_STUDI_LIST, data);
  },
  getStudiDetail(id) {
    return BaseInstance.fetch(DATA_UTAMA_PENDIDIKAN_STUDI_DETAIL, id);
  },
  saveStudi(data) {
    return BaseInstance.post(DATA_UTAMA_PENDIDIKAN_STUDI_SAVE, data);
  },
  deleteStudi(params) {
    return BaseInstance.remove(DATA_UTAMA_PENDIDIKAN_STUDI_DELETE, { params });
  },
  // Pendidikan Level
  getPendidikanLevelList(data) {
    return BaseInstance.post(DATA_UTAMA_PENDIDIKAN_LEVEL_LIST, data);
  },
  getPendidikanLevelDetail(id) {
    return BaseInstance.fetch(DATA_UTAMA_PENDIDIKAN_LEVEL_DETAIL, id);
  },
  savePendidikanLevel(data) {
    return BaseInstance.post(DATA_UTAMA_PENDIDIKAN_LEVEL_SAVE, data);
  },
  deletePendidikanLevel(params) {
    return BaseInstance.remove(DATA_UTAMA_PENDIDIKAN_LEVEL_DELETE, { params });
  },
  getPendidikanLevelLOV(params) {
    return BaseInstance.query(DATA_UTAMA_PENDIDIKAN_LEVEL_ALL, { params });
  },
  // Rumpun
  getPendidikanRumpunList(params) {
    return BaseInstance.query(DATA_UTAMA_PENDIDIKAN_RUMPUN_LIST, { params });
  },
  getPendidikanRumpunDetail(id) {
    return BaseInstance.fetch(DATA_UTAMA_PENDIDIKAN_RUMPUN_DETAIL, id);
  },
  savePendidikanRumpun(data) {
    return BaseInstance.post(DATA_UTAMA_PENDIDIKAN_RUMPUN_SAVE, data);
  },
  deletePendidikanRumpun(params) {
    return BaseInstance.remove(DATA_UTAMA_PENDIDIKAN_RUMPUN_DELETE, { params });
  },
  getUnitKerjaGroupLOV(params) {
    return BaseInstance.query(DATA_UTAMA_UNIT_KERJA_GROUP, { params });
  }
};

export default DataUtamaService;
